import { render, staticRenderFns } from "./DelTopic.vue?vue&type=template&id=b29beea0&"
import script from "./DelTopic.vue?vue&type=script&lang=js&"
export * from "./DelTopic.vue?vue&type=script&lang=js&"
import style0 from "./DelTopic.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports